<div class="main-content">
  <mat-slide-toggle (change)="switchMode($event)">
    <span class="info">iOS Preview</span>
  </mat-slide-toggle>
</div>
@if (loading) {
  <mat-spinner></mat-spinner>
}
@if (!loading) {
  <div class="wrapper-on-all">
    <div class="tree" [ngClass]="{ 'fixed-mode-tree': fieldConfig.treeOptions.formFixedPositioned }">
      <mat-tree
        [dataSource]="dataSource"
        [treeControl]="treeControl"
        cdkDropList
        (cdkDropListDropped)="drop($event)"
        class="example-tree">
        <!-- This is the tree node template for leaf nodes -->
        <mat-tree-node
          *matTreeNodeDef="let node"
          matTreeNodePadding
          cdkDrag
          [cdkDragData]="node"
          (mouseenter)="mouseEntered(node)"
          (mouseleave)="mouseLeft(node)"
          data-id="node">
          <li class="mat-tree-node" (click)="clickOnNode(node)" [ngClass]="{ active: node.active }">
            <!-- use a disabled button to provide padding for tree leaf -->
            <button
              [attr.data-id]="'nodeFolderName_' + node.entity.code"
              mat-icon-button
              matTreeNodeToggle
              [attr.aria-label]="'toggle ' + node.title"
              (click)="onNodeToggle(node)">
              <mat-icon class="mat-icon-rtl-mirror">
                {{ treeControl.isExpanded(node) ? 'folder_open' : 'folder' }}
              </mat-icon>
            </button>
            <span class="directory-tree-label">
              <span>
                <b [attr.data-id]="'nodeName_' + node.entity.code">{{ node.entity.title }}</b>
                @for (tag of node.entity.tags; track tag) {
                  <span class="title-tag" data-id="nodeAttribute" [innerHTML]="tag"></span>
                }
              </span>
              @if (!node.entity.reorderBlocked) {
                <span [hidden]="readOnly || (!node.hovered && !node.active)" class="directory-tree-label-buttons">
                  @if (!!type.deleteUrl && (!node.entity.fixed || node.entity.aliasOf)) {
                    <button mat-icon-button color="accent" (click)="delete(node)">
                      <mat-icon class="mat-icon-rtl-mirror"> delete </mat-icon>
                    </button>
                  }
                  @if (node.level + 1 < fieldConfig.treeOptions.depth && !node.entity.fixed) {
                    <button mat-icon-button color="accent" (click)="newForParent(node.entity.id, $event)">
                      <mat-icon class="mat-icon-rtl-mirror"> create_new_folder </mat-icon>
                    </button>
                  }
                  <button mat-icon-button color="accent" (click)="editNode(node)">
                    <mat-icon class="mat-icon-rtl-mirror"> edit </mat-icon>
                  </button>
                  @if (type.reorderUrl) {
                    <button mat-icon-button color="accent" cdkDragHandle [hidden]="node.entity.reorderBlocked">
                      <mat-icon class="mat-icon-rtl-mirror">
                        <svg width="24px" fill="currentColor" viewBox="0 0 24 24">
                          <path
                            d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"></path>
                          <path d="M0 0h24v24H0z" fill="none"></path>
                        </svg>
                      </mat-icon>
                    </button>
                  }
                </span>
              }
            </span>
          </li>
        </mat-tree-node>
        <!-- This is the tree node template for expandable nodes -->
        <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding cdkDrag [cdkDragData]="node">
          <li (click)="clickOnNode(node)" (mouseenter)="mouseEntered(node)" (mouseleave)="mouseLeft(node)">
            <div class="mat-tree-node" [ngClass]="{ active: node.active }">
              <b>
                <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'toggle ' + node.title">
                  <mat-icon class="mat-icon-rtl-mirror">
                    {{ treeControl.isExpanded(node) ? 'folder_open' : 'folder' }}
                  </mat-icon>
                </button>
              </b>
              <span class="directory-tree-label">
                <span>
                  <b
                    ><span>{{ node.title }}</span></b
                  >
                </span>
                <span [hidden]="!node.hovered && !node.active" class="directory-tree-label-buttons">
                  @if (!!type.deleteUrl && (!node.entity.fixed || node.entity.aliasOf)) {
                    <button mat-icon-button color="accent" (click)="delete(node)">
                      <mat-icon class="mat-icon-rtl-mirror"> delete </mat-icon>
                    </button>
                  }
                  @if (node.level + 1 < fieldConfig.treeOptions.depth && !node.entity.fixed) {
                    <button mat-icon-button color="accent" (click)="newForParent(node.entity.id, $event)">
                      <mat-icon class="mat-icon-rtl-mirror"> create_new_folder </mat-icon>
                    </button>
                  }
                  <button mat-icon-button color="accent" (click)="editNode(node)">
                    <mat-icon class="mat-icon-rtl-mirror"> edit </mat-icon>
                  </button>
                  @if (type.reorderUrl) {
                    <button mat-icon-button color="accent" cdkDragHandle>
                      <mat-icon class="mat-icon-rtl-mirror">
                        <svg width="24px" fill="currentColor" viewBox="0 0 24 24">
                          <path
                            d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"></path>
                          <path d="M0 0h24v24H0z" fill="none"></path>
                        </svg>
                      </mat-icon>
                    </button>
                  }
                </span>
              </span>
            </div>
            <ul [class.example-tree-invisible]="!treeControl.isExpanded(node)">
              <ng-container matTreeNodeOutlet></ng-container>
            </ul>
          </li>
        </mat-tree-node>
      </mat-tree>
      @if (!readOnly && fieldConfig.canReorder) {
        <div class="add-new" (click)="newForParent(0, $event)" [ngClass]="{ active: creatingNew }">
          <button mat-icon-button>
            <mat-icon class="mat-icon-rtl-mirror"> create_new_folder </mat-icon>
          </button>
          <span>Create new</span>
        </div>
      }
    </div>
    @if (activeNode || creatingNew) {
      <mat-card class="details-page" [ngClass]="{ 'fixed-mode-form': fieldConfig.treeOptions.formFixedPositioned }">
        <div>
          @if (activeNodeLoading) {
            <div class="loading-spinner">
              <mat-spinner [diameter]="24"></mat-spinner>
            </div>
          }
          <div class="active-node-title">
            <h2>{{ activeNode ? activeNode.entity.title : 'Create new' }}</h2>
            @if (!editMode && !readOnly) {
              <button mat-icon-button color="accent" (click)="editNode(activeNode)" data-id="editBtn">
                <mat-icon class="mat-icon-rtl-mirror"> edit </mat-icon>
              </button>
            }
          </div>
          <table>
            @for (field of getFields(); track field) {
              <tr class="field-row">
                @if (!field.formFullWidth) {
                  <td class="field-label">{{ field.label }}</td>
                }
                <td class="field-form-element" [attr.colspan]="field.formFullWidth ? 2 : 1">
                  <app-form-field
                    [type]="field.type"
                    [data]="formGroupSubset.getRawValue()[field.name]"
                    [rowData]="formGroupSubset.getRawValue()"
                    [fieldConfig]="field"
                    [(editMode)]="editMode"
                    [hasFilters]="true"
                    [attr.data-id]="'formField_' + field.name"
                    [formGroup]="formGroupSubset"></app-form-field>
                </td>
              </tr>
            }
          </table>
          @if (editMode) {
            <div class="edit-buttons">
              @if (!creatingNew) {
                <button mat-raised-button color="primary" data-id="updateBtn" (click)="updateActiveNode()">
                  Update
                </button>
              }
              @if (creatingNew) {
                <button mat-raised-button color="primary" data-id="createBtn" (click)="createNew()">Create</button>
              }
              <button mat-button color="accent" data-id="cancelBtn" (click)="cancelUpdating()">Cancel</button>
            </div>
          }
        </div>
      </mat-card>
    }
  </div>
}
